export { VitalsSection } from './VitalsSection';
export { NotesSection } from './NotesSection';
